module.exports = __webpack_public_path__ + "img/logo.9abb110c.svg";